const MedicalProgramsList = {
    '8a11c513-e7a9-4800-9fb9-becb743e08c4': 'Імуносупресивні лікарські засоби',
    '14e19712-b443-4391-b0f7-aba8e8662459': 'Нецукровий діабет',
    'f217889f-736f-462c-8f8b-ed99edddb3be': 'Розлади психіки та поведінки',
    '9d94a21b-ec70-4b91-946a-981f4db8d2b9': 'Епілепсія',
    '0eececf1-aaf5-48fb-87e2-da44b7c49db2': 'Хвороба Паркінсона',
    '9a1364d7-2c61-4fe8-b889-ea788dbb7467': 'Інсуліни з доплатою',
    '9994be00-47b4-4969-800e-87a767751b47': 'Інсуліни безоплатно',
    'e9c6beeb-b19f-4b97-b42a-020c5c996c56': 'Інсуліни аналоги (з доплатою)',
    '7335a30e-61f2-42b0-9ed4-2afe847bba16': 'Інсуліни аналоги (безоплатно)',
    'cda113e4-b8dd-4ec4-a878-3d1c7eae49da': 'Інсуліни людські (флакони безоплатно)',
    '857588d8-9e12-4935-96c4-b08e95d19dce': 'Інсуліни людські (картриджи та шприцручки з доплатою)',
    '8efe29df-18bd-4d49-8995-c3f7e44d9e12': 'Інсуліни людські (картриджи та шприцручки безоплатно)',
    '5562904e-100f-11ee-be56-0242ac120002': 'Опіоїдні анальгетики',
    '9723a9a0-100a-11ee-be56-0242ac120002': 'Опіоїдні анальгетики для лікування РПП',
    '0cefbce3-6dd2-45bd-b1e6-983fc055d5e0': 'Медичні вироби для визначення рівня глюкози в крові',
    '786ac2aa-af37-4bd0-b1f5-40a017bf2237': 'Постанова КМУ №1380 від 03.12.2024',
    'b15d6bfa-66a4-40ba-9965-ef7712f48da9': 'Серцево-судинні та цереброваскулярні захворювання',
    '2adffeff-be3c-4a23-92a3-2cf4a34a2972': 'Хронічні хвороби нижніх дихальних шляхів',
    '014d1d27-a0fc-4591-81cf-46fa6ea2999d': 'Цукровий діабет (пероральні гіпоглікемізуючі лікарські засоби)',
    '276faa17-d6cd-4781-9166-fd2c16af20a0': 'Хвороби ендокринної системи',
    '414e1aa4-2a5d-4a23-9312-9f8b1847fa3b': 'Метаболічні, аутоімунні та запальні захворювання',
    '66a96847-49c0-43d9-b578-f229ba3b33e7': 'Глаукома',
    '83eee31e-3bb5-49cf-9f90-fde1be13dc95': 'Мігрень',
    '75977dc6-49ce-4bb2-aa0f-9100c2edf440': 'Дитячі захворювання',
    '638ec6b8-d461-4399-ac28-5341a2fcffd5': 'Лікування вагітних та породілей',
    '96e1cf78-6524-456c-b8a9-f68177f42597': 'Онкологічні захворювання'
};

export default MedicalProgramsList;